export const SERVICE_ENDPOINTS = {
  GET_USER_CURRENT: '/users/self/me',
  GET_USER_BY_ID: '/users/id/',
  GET_USERS_ORG: '/users/org/',
  GET_USERS_ORG_INIT: '/users/org/',
  CREATE_TRANSACTION: '/transaction/',
  GET_TRANSACTION: '/transaction/',
  GET_TRANSACTIONS: '/transactiondata',
  GET_TRANSACTIONS_TENANT: '/transactiondata/tenant/',
  GET_PAYMENT_METHODS: '/payment-method?enabled=true',
  GET_PAYMENT_METHODS_CONFIG: '/payment-method-config',
  CREATE_PAYMENT_TYPE: '/payment-type',
  CREATE_PAYMENT_TYPE_ADMIN: '/payment-type/tenant/',
  GET_PAYMENT_TYPE: '/payment-type/',
  GET_PAYMENT_TYPES: '/payment-type',
  GET_PAYMENT_TYPES_TENANT: '/payment-type/tenant/',
  GET_PAYMENT_TYPES_LEAD: '/payment-type/tenant/',
  GET_PAYMENT_TYPES_TENANT_CHARGEBACK: '/payment-type/tenant/',
  UPDATE_PAYMENT_TYPE: '/payment-type/',
  UPDATE_PAYMENT_TYPES_ACTIVATION_REQUEST: '/payment-type/request-activation',
  CREATE_PAYMENT_PAGE: '/payment-page',
  GET_PAYMENT_PAGE: '/payment-page',
  UPDATE_PAYMENT_PAGE: '/payment-page/',
  CREATE_PAYMENT_PAGE_LINK: '/payment-link',
  GET_PAYMENT_PAGE_LINKS: '/payment-link/by-payment-page',
  UPDATE_PAYMENT_PAGE_LINK: '/payment-link/',
  GET_ORGANISATION: '/organisations/',
  GET_ORGANISATIONS: '/organisations',
  GET_ORGANISATIONS_ONBOARDING: '/organisations/admin/onboarding',
  GET_ORGANISATIONS_REFERRAL_PARTNER: '/organisations/admin/referral-partner',
  GET_ORGANISATIONS_DATA_CENTER: '/organisations/admin/data-center',
  GET_ORGANISATIONS_LEAD: '/organisations/lead/assigned',
  UPDATE_ORGANISATIONS: '/organisations/self/me',
  UPDATE_ORGANISATIONS_ADMIN: '/organisations/',
  CREATE_SHOP_CONTRACT: '/organisations/createShop',
  GET_CC_WITH_ACTIVE_CONTRACT: '/payment-type/creditcards-with-active-contract/',
  CREATE_NEW_LEAD_INQUIRY: '/leads',
  CREATE_SUPPORT_REQUEST: '/contact-support',
  GET_PAYOUT_CSV: '/payout/csv/',
}
